import { D2D_CHANNEL } from "../../../../constants/treeConstants";
import { newExtractionInfo } from "../../helper/IntegratedInterface";

const NetNamePrefix = 'netNamePrefix', EXCLUDE = "EXCLUDE", COMPONENT = "component";
const DATA = 'DATA', CLK = 'CLK', VLD = 'VLD', TRK = 'TRK', DATARD = "DATARD", CKRD = "CKRD", VLDRD = "VLDRD", DATASB = "DATASB", CKSB = "CKSB", DATASBRD = "DATASBRD", CKSBRD = "CKSBRD";
const CLKDefault = ['CK', 'DQS'], DATADefault = ['DATA', 'IO'], VLDDefault = ['VLD'], TRKDefault = ['TRK'], DATARDDefault = ['DATARD'], CKRDDefault = ['CKRD'], VLDRDDefault = ['VLDRD'], DATASBDefault = ['DATASB'], CKSBDefault = ['CKSB'], DATASBRDDefault = ['DATASBRD'], CKSBRDDefault = ['CKSBRD'];
function defaultIdentificationInfo({ type, id, name, config }) {
  this.type = type || "";
  this.id = id || "";
  this.name = name || "";
  this.config = id ? config && Object.keys(config) ? config : new defaultAdvanceConfig({}) : {};
  this.netList = [];
  this.selectNetList = [];
}

function defaultAdvanceConfig({ netNamePrefix, isRegular, EXCLUDE, excludeIsRegular, component, CLK, DATA, VLD, TRK, CKRD, DATARD, VLDRD, DATASB, CKSB, DATASBRD, CKSBRD }) {
  this.netNamePrefix = netNamePrefix || ['TX', 'RX'];
  this.isRegular = isRegular || false;
  this.excludeIsRegular = excludeIsRegular || true;
  this.component = component || "";
  this.DATA = DATA || DATADefault;
  this.CLK = CLK || CLKDefault;
  this.VLD = VLD || VLDDefault;
  this.TRK = TRK || TRKDefault;
  this.CKRD = CKRD || CKRDDefault;
  this.DATARD = DATARD || DATARDDefault;
  this.VLDRD = VLDRD || VLDRDDefault;
  this.DATASB = DATASB || DATASBDefault;
  this.CKSB = CKSB || CKSBDefault;
  this.DATASBRD = DATASBRD || DATASBRDDefault;
  this.CKSBRD = CKSBRD || CKSBRDDefault;
  this.EXCLUDE = EXCLUDE || [];
}

function getAdvanceInput(key) {
  switch (key) {
    case NetNamePrefix:
      return {
        key: NetNamePrefix,
        title: 'Net name keywords',
        multiple: true
      }
    case EXCLUDE:
      return {
        key: key,
        title: "EXCLUDE"
      }
    case COMPONENT:
      return {
        key: key,
        title: "Component"
      }
    case CLK:
      return {
        key: key,
        title: "CLK",
        multiple: true,
        description: "Transmit/Receive Clock"
      }
    case DATA:
      return {
        key: key,
        title: "DATA",
        multiple: true,
        description: "Transmit/Receive Data"
      }
    case VLD:
      return {
        key: key,
        title: "VLD",
        multiple: true,
        description: "Transmit/Receive Data Valid; Enables clocking in corresponding module"
      }
    case TRK:
      return {
        key: key,
        title: "TRK",
        multiple: true,
        description: "Transmit/Receive Track signal"
      }
    case DATARD:
      return {
        key: key,
        title: "DATARD",
        multiple: true,
        description: "Redundant for Data Lane repair"
      }
    case CKRD:
      return {
        key: key,
        title: "CKRD",
        multiple: true,
        description: "Redundant for Clock and Track Lane repair"
      }
    case VLDRD:
      return {
        key: key,
        title: "VLDRD",
        multiple: true,
        description: "Redundant for Valid"
      }
    case DATASB:
      return {
        key: key,
        title: "DATASB",
        multiple: true,
        description: "Sideband Transmit/Receive Data"
      }
    case CKSB:
      return {
        key: key,
        title: "CKSB",
        multiple: true,
        description: "Sideband Transmit/Receive Clock"
      }
    case DATASBRD:
      return {
        key: key,
        title: "DATASBRD",
        multiple: true,
        description: "Redundant Sideband Transmit/Receive Data"
      }
    case CKSBRD:
      return {
        key: key,
        title: "CKSBRD",
        multiple: true,
        description: "Redundant Sideband Transmit/Receive Clock"
      }
    default: return;
  }
}

function getIdentificationAdvancesInputList(advancedConfig) {
  let keys = Object.keys(advancedConfig)
  if (!keys && keys.length) { return [] }
  keys = keys.filter(item => !['type', 'isRegular', "excludeIsRegular"].includes(item))
  const identificationAdvancesInputList = keys.map(key => { return getAdvanceInput(key) })
  return identificationAdvancesInputList
}

export class RockyD2DInterface {
  constructor(designId) {
    this.Signals = []; // [Signal]
    this.Components = [];
    this.PowerNets = [];
    this.Ports_generate_setup_list = [];
    this.ReferenceNets = [];
    this.Port_setups = [];
    this.designId = designId;
    this.extraction = new newExtractionInfo({ config: {}, type: "HFSS", pageType: D2D_CHANNEL, noDistinctionByteCA: false, isNew: true })
  }
}

export {
  defaultIdentificationInfo,
  defaultAdvanceConfig,
  getIdentificationAdvancesInputList
}